function fixAccessibility() {
    wpToolbarIssues();
    googleTranslatePreloader();
}

/**
 * Issue: Content is not within a landmark element
 * Explanation: We should avoid having not a HTML5 sectioning element without a role attribute.
 * Therefore, we need to add a certain role attribute value to the WP toolbar element
 * Element: #wpadminbar
 */
function wpToolbarIssues() {
    const wpToolbar = document.getElementById('wpadminbar');
    if (wpToolbar) {
        wpToolbar.setAttribute('role', 'contentinfo');
    }
}

/**
 * Add for svg preloader role attribute.
 */
function googleTranslatePreloader() {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (
                    node.nodeType === 1 &&
                    node.parentElement === document.body
                ) {
                    node.querySelectorAll('svg').forEach((svg) => {
                        svg.setAttribute('role', 'presentation');
                    });
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
}

export default fixAccessibility;
